import { useMutation } from '@tanstack/react-query';

import { apiClient, type ApiError } from '@/_shared';

import type { DeliverablesCreateSchema, DeliverablesQuerySchema, DeliverablesUpdateSchema } from './schemas';
import type { OverridePayload } from './wholesale-api';

export const useCreateMutation = () =>
  useMutation<{ data: DeliverablesQuerySchema }, ApiError, DeliverablesCreateSchema>({
    mutationKey: ['AGREEMENT_DELIVERABLE_CREATE'],
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: '/api/v1/agreement-deliverables/',
        payload,
      }),
  });

export const useDeliverableBulkCreateMutation = () =>
  useMutation<DeliverablesQuerySchema[], ApiError, { items: DeliverablesCreateSchema[] }>({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: `/api/v1/agreement-deliverables/bulk-store`,
        method: 'POST',
        payload,
      }),
  });

export const useUpdateDeliverablesMutation = () =>
  useMutation<{ data: DeliverablesQuerySchema }, ApiError, Partial<DeliverablesUpdateSchema>>({
    mutationFn: ({ id: bId, ...payload }) =>
      apiClient.request({
        endpoint: `/api/v1/agreement-deliverables/${bId}`,
        method: 'PATCH',
        payload,
      }),
  });

export const useDeliverableBulkUpdateMutation = () =>
  useMutation<{ data: DeliverablesQuerySchema }, ApiError, { items: DeliverablesUpdateSchema[] } & OverridePayload>({
    mutationFn: (payload) =>
      apiClient.request({
        endpoint: `/api/v1/agreement-deliverables/bulk-update`,
        method: 'POST',
        payload,
      }),
  });

export const useDeliverableDeleteMutation = () =>
  useMutation<unknown, unknown, { id: number; lockdown_override_pin?: string; override_justification_note?: string }>({
    mutationKey: ['AGREEMENT_DELIVERABLE_DELETE'],
    mutationFn: ({ id, ...payload }) =>
      apiClient.request({
        endpoint: `/api/v1/agreement-deliverables/${id}`,
        method: 'DELETE',
        payload,
      }),
  });
